import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
// app modules
import {ApiModule} from '../api/api.module';
import {CommonsModule} from '../commons/commons.module';
import {I18nModule} from '../i18n/i18n.module';
import {SharedModule} from '../shared/shared.module';
// app view modules
import {OnboardingComponent} from './onboarding/onboarding.component';
import {OnboardingCompletedComponent} from './onboarding-completed/onboarding-completed.component';
import {OnboardingResolverService} from './onboarding/onboarding-resolver.service';
import {CustomerConfigResolverService} from './onboarding/customer-config-resolver.service';
import {OnboardingInvalidComponent} from './onboarding-invalid/onboarding-invalid.component';
import {OnboardingGuard} from './onboarding.guard';
import {SpinnerComponent} from '../shared/spinner/spinner.component';


@NgModule({
    declarations: [
        OnboardingComponent,
        OnboardingCompletedComponent,
        OnboardingInvalidComponent,
        SpinnerComponent
    ],
    imports: [
        // angular
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        // application
        ApiModule,
        CommonsModule,
        I18nModule,
        SharedModule
    ],
    exports: [
        OnboardingComponent,
        OnboardingCompletedComponent,
        OnboardingInvalidComponent
    ]
})
export class ViewsModule {

    /**
     * Configures the ViewsModule.
     *
     * @return The module with the providers
     */
    static forRoot(): ModuleWithProviders<ViewsModule> {
        return {
            ngModule: ViewsModule,
            providers: [
                OnboardingResolverService,
                CustomerConfigResolverService,
                OnboardingGuard
            ]
        };
    }
}
